import { call, put, takeLatest, fork, all, delay } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import { sagaWrapper, sagaErrorHandler } from '../helpers/functions';
import * as GeneralService from './../services/generalService';
import i18n from '../constants/initLng';
import { message } from 'antd'
import * as GeneralActions from './../actions/generalAction';

function* getListProvices() {
    yield takeLatest(Types.PROVINCE_LIST_ACTION, sagaWrapper(function* (action) {
        const result = yield call(GeneralService.getProvinces, action.countryCode);
        yield put(GeneralActions.setListProvinces(result));
    }, errorHandleFlight(Types.PROVINCE_LIST_FAIL)))
}


function* getFlightConfig() {
    yield takeLatest(Types.FLIGHT_CONFIG_GET, sagaWrapper(function* (action) {
        const result = yield call(GeneralService.getFlightConfig);
        yield put(GeneralActions.setFlightConfig(result));
    }, errorHandleFlight(Types.FLIGHT_CONFIG_FAIL)))
}

function* updateFlightConfig() {
    yield takeLatest(Types.FLIGHT_CONFIG_UPDATE, sagaWrapper(function* (action) {
        const result = yield call(GeneralService.updateFlightConfig, action.flightConfig);
        yield put(GeneralActions.setFlightConfig(result));
    }, errorHandleFlight(Types.FLIGHT_CONFIG_FAIL)))
}

function* getListExchangeRates() {
    yield takeLatest(Types.EXCHANGE_RATE_LIST_ACTION, sagaWrapper(function* (action) {
        const result = yield call(GeneralService.getExchangeRates);
        yield put(GeneralActions.setListExchangeRates(result));
    }, errorHandleFlight(Types.EXCHANGE_RATE_FAIL)))
}

function* updateExchangeRate() {
    yield takeLatest(Types.EXCHANGE_RATE_UPDATE_ACTION, sagaWrapper(function* (action) {
        yield call(GeneralService.updateExchangeRate, action.exchangeRate);
        yield put(GeneralActions.setExchangeRate(action.exchangeRate));
        yield put({ type: Types.EXCHANGE_RATE_LIST_ACTION, withoutLoading: true })
    }, errorHandleFlight(Types.EXCHANGE_RATE_FAIL)))
}


function errorHandleFlight(errorActionType) {
    return sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    });
}


export function* generalSaga() {
    yield all([
        fork(getListProvices),
        fork(getFlightConfig),
        fork(updateFlightConfig),
        fork(getListExchangeRates),
        fork(updateExchangeRate),
    ])
}
